import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import {
  clickableFrameLinkStyles,
  clickableFrameStyles,
} from "scmp-app/components/content/content-item-render/clickable-frame/styles";
import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const ActionBarContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export const ActionBar = styled.div`
  position: relative;

  padding-inline-end: 9.4px;

  &::after {
    position: absolute;
    inset-block-start: 50%;
    inset-inline-end: 0;
    content: "|";

    color: #727272;

    transform: translateY(-50%);
  }

  time {
    color: #727272;
    font-weight: 400;
    font-size: 11px;
    font-family: ${fontRoboto};
    line-height: 100%;
  }
`;

export const Section = styled.div`
  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    font-family: ${fontRobotoCondensed};
    line-height: 100%;
    text-transform: uppercase;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  ${clickableFrameLinkStyles}
  color: #000000;
`;

export const Container = styled.div`
  ${clickableFrameStyles(StyledEntityLink)}
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Headline = styled.div`
  font-weight: 600;
  font-size: 18px;
  font-family: ${fontSourceSerif4};
  line-height: 130%;
  letter-spacing: -0.36px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
    letter-spacing: -0.32px;
  }
`;
